import { Screen } from '@betty/navigation';
import { PaymentMethodVerificationSuccessScreenProps } from './PaymentMethodVerificationSuccessScreen.types';
import PaymentMethodVerificationSuccess from '../../../components/PaymentMethodVerification/PaymentMethodVerificationSuccess/PaymentMethodVerificationSuccess';

function PaymentMethodVerificationSuccessScreen({
  route,
}: PaymentMethodVerificationSuccessScreenProps) {
  return (
    <Screen>
      <PaymentMethodVerificationSuccess {...route.params} />
    </Screen>
  );
}

export default PaymentMethodVerificationSuccessScreen;
